import { useRouter } from "next/router";

import { useGetDeviceType }    from "_common/hooks/global";
import { useRemoveQueryParam } from "_common/hooks/useQueryParams";
import MantineThemeProvider    from "_components/templates/mantineDarkProvider";

import Presentation from "./presentation";

const component = () => {
	const router           = useRouter ();
	const deviceType       = useGetDeviceType ();
	const removeQueryParam = useRemoveQueryParam ();
	const isMobile         = deviceType === "mobile";
	const queryParam       = router.query.nowPro;

	function handleClickDone () {
		removeQueryParam ( "nowPro" );
	}

	return (
		<MantineThemeProvider type = { "dark" }>
			<Presentation
				handleClickDone = { handleClickDone }
				isMobile = { isMobile }
				onClose = { () => { } }
				opened = { queryParam }
			/>
		</MantineThemeProvider>
	);
};

export default component;
